import React from 'react';
import { COACH_GET_STARTED_CLICKED_EVENT } from 'constants/analytics';
import { CURRENCY_USD } from 'constants/currency';
import { trackEvent } from 'services/client/analytics';
import { convertUnitPriceToFormattedPrice } from 'utils/shared/money/convertUnitPriceToFormattedPrice';
import { getLessonItemizedTotal } from 'utils/shared/money/getLessonItemizedTotal';
import Button from 'components/Button';
import { Steps, VideoAnalysisSubmissionProps } from '../types';

const VideoAnalysis = ({ coach, setSteps }: VideoAnalysisSubmissionProps) => {
  const coachPrice = coach?.priceUnitAmountRemoteCoachDefault ?? 0;
  const params = {
    priceUnitAmount: coachPrice,
  };
  const lessonTotal = getLessonItemizedTotal(params);

  const clickGetStarted = () => {
    trackEvent(COACH_GET_STARTED_CLICKED_EVENT, {
      coachId: coach?.id,
      surface: 'video_analysis',
    });
    setSteps(Steps.VideoUploader);
  };

  return (
    <div className="flex flex-col gap-8 p-6">
      <h2 className="typography-product-heading inline flex-1 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary lg:hidden">
        Remote coaching
      </h2>
      <div className="flex w-full flex-row items-center justify-between">
        <h2 className="typography-product-heading flex-1 text-color-text-brand dark:text-color-text-brand">
          Video analysis
        </h2>
        <span className="typography-product-heading text-color-text-brand">
          {
            convertUnitPriceToFormattedPrice(
              lessonTotal?.orderSubtotalWithPlatformFeesUnitAmount ?? 0,
              coach?.stripeMerchantCurrency || coach?.currencyCoachDefault || CURRENCY_USD,
            ).priceDisplay
          }
        </span>
      </div>
      <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        Submit a video of you playing and I’ll give you point-by-point feedback.
      </p>
      <div className="flex w-full flex-col gap-4">
        {/* Hide for future use */}
        {/* <Button variant="inverted" size="lg" label="View sample lesson" /> */}

        <Button variant="brand" size="lg" label="Get started" onClick={clickGetStarted} />
      </div>
    </div>
  );
};

export default VideoAnalysis;
